import { useCallback, useEffect } from 'react';
import _throttle from 'lodash/throttle';
import type { ThrottleSettings } from 'lodash';

type Callback = (...args: unknown[]) => void;

export default function useThrottledCallback(
  cb: Callback,
  deps: unknown[],
  delay: number,
  throttleConfig: ThrottleSettings = {}
): Callback {
  const callback = useCallback(_throttle(cb, delay, throttleConfig), deps);

  useEffect(() => {
    const lastCallback = callback;

    return () => lastCallback.cancel();
  }, [callback]);

  return callback;
}
